<div class="tss">
  <span class="tss__label">{{ 'termScope.label' | translate }}</span>
  <div
    class="tss__group"
    role="radiogroup"
    [attr.aria-label]="'termScope.ariaLabel' | translate"
    (keydown)="onKeydown($event)">
    @for (option of options; track option.value) {
      <button
        #radioButton
        type="button"
        role="radio"
        class="tss__segment"
        [class.tss__segment--selected]="value() === option.value"
        [class.tss__segment--all]="option.value === 'all'"
        [class.tss__segment--perpetual]="option.value === 'perpetual'"
        [class.tss__segment--fixed]="option.value === 'fixed'"
        [attr.aria-checked]="value() === option.value"
        [attr.tabindex]="value() === option.value ? 0 : -1"
        [disabled]="disabled()"
        (click)="select(option.value)">
        {{ option.labelKey | translate }}
      </button>
    }
  </div>
</div>
